// extracted by mini-css-extract-plugin
module.exports = {"balls":"BouncingBalls_balls__zdNHS","left-swing":"BouncingBalls_left-swing__NQmCn","right-swing":"BouncingBalls_right-swing__3CLM6"};